<template>
  <div
    class="container bottom-border"
    :class="{ 'hide-bottom-border': hideborder }"
  >
    <div class="content">
      <div
        v-if="icon"
        class="icon icon-center"
        :class="{ 'icon-top': icontop }"
      >
        <Icons
          :icon="icon"
          :height="icon_height"
          :width="icon_width"
          :stroke="icon_fill"
        />
      </div>
      <div class="contents-container">
        <div class="content-container">
          <p class="title">{{ rtitle }}</p>
          <div class="content-body"><slot></slot></div>
        </div>
        <slot name="mcontent"></slot>
        <div v-if="linfo" class="content-container" style="width: auto">
          <p class="title">{{ ltitle }}</p>
          <div class="content-body"><slot name="lcontent"></slot></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icons from "@/components/Icons/Icons.vue";
export default {
  props: [
    "icon",
    "icon_width",
    "icon_height",
    "icon_fill",
    "icontop",
    "rtitle",
    "ltitle",
    "linfo",
    "hideborder",
  ],
  components: { Icons },
};
</script>

<style lang="scss" scoped>
.bottom-border {
  border-bottom: 1px solid #dedede;
}
.hide-bottom-border {
  border-bottom-width: 0px;
}
.container * {
  margin: 0px;
  font-style: normal;
  width: 100%;
}
.contents-container {
  display: flex;
  justify-content: space-between;
}
.content-container {
  line-height: 120%;
}
.content-body {
  color: #000;
  font-size: 13px;
  font-weight: 400;
}
.title {
  color: #7b7b7b;
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  width: max-content;
}
.icon {
  display: flex;
  width: auto;
}
.icon-center {
  align-items: center;
}
.icon-top {
  align-items: start;
}
.content {
  display: flex;
  justify-content: center;
  gap: 10px;
}
.container {
  display: flex;
  padding: 8px 0px;
  align-items: center;
  gap: 15px;
  align-self: stretch;
}
</style>
